import axios from 'axios';
import to from 'await-to-js';
import { omit } from 'lodash';
import { defineStore } from 'pinia';

export const useFilesStore = defineStore('files', {
  state: () => ({
    loading: false,
    uploadedFile: null,
  }),
  actions: {
    async getDownloadToken() {
      this.loading = true;
      const [err, res] = await to(axios.post('/api/token/download'));
      this.loading = false;
      if (err) throw new Error(err.message);
      return res.data.downloadToken;
    },

    async deleteFile({ fileId }) {
      this.loading = true;
      const [err] = await to(axios.delete(`/api/file/${fileId}`));
      this.loading = false;
      this.uploadedFile = null;
      if (err) throw new Error(err.message);
    },

    async uploadCSV({ formData = {}, service }) {
      this.loading = true;
      const [err, res] = await to(
        axios.post(`/api/csv/${service}/upload`, formData, {
          headers: {
            // Now axios 1.x set the Content-Type to 'application/json' automatically so in order to have the value as 'FormData/HTMLForm' we need to set as undefined
            // You can read more about in the axios migration guide to v1.x on https://github.com/bmuenzenmeyer/axios-1.0.0-migration-guide?tab=readme-ov-file#multipart-form-data-is-no-longer-automatically-set
            'Content-Type': undefined,
          },
        })
      );
      this.loading = false;
      if (err) throw new Error(err.message);
      this.uploadedFile = res.data.uploadedFile;
      return res.data.uploadedFile;
    },

    async uploadFileToFtp(file) {
      const { blobId } = file;
      const fileWithoutJobs = omit(file, ['jobs']);
      this.loading = true;
      const [err, res] = await to(
        axios.post(`/api/file/export-to-ftp/${blobId}`, { file: fileWithoutJobs })
      );
      if (err) throw new Error(err.message);
      this.loading = false;
      return res.data.uploadedFile;
    },
    setUploadedFile(file) {
      this.uploadedFile = file;
    },
  },
});
